import "core-js/modules/es.array.push.js";
import api from "@/api";
import WatermarkerView from "@/components/WatermarkerView";
export default {
  name: "HomeView",
  components: {
    WatermarkerView
  },
  data() {
    return {
      tab: 0,
      isFlashPractice: false,
      user: {},
      accountUsageEnum: {
        // 上课
        class: 1,
        // 刷机
        flash: 2,
        flashAndClass: 3
      }
    };
  },
  mounted() {
    api.getUserInfo().then(ret => {
      this.user = ret.info;
      // 刷机练习
      this.isFlashPractice = this.user.accountUsage == this.accountUsageEnum.flash || this.user.accountUsage == this.accountUsageEnum.flashAndClass;
      this.isClass = this.user.accountUsage == this.accountUsageEnum.class || this.user.accountUsage == this.accountUsageEnum.flashAndClass;
      if ('ADMIN' == ret.info.userTag) {
        localStorage.setItem('waterMarker', '');
      } else {
        localStorage.setItem('waterMarker', `${ret.info.nickName}${ret.info.phone}`);
      }
      if (this.isClass) {
        if (this.$route.path.startsWith('/class/room')) {
          this.tab = 1;
        } else if (this.$route.path.startsWith('/answer/history')) {
          this.tab = 2;
        } else if (this.$route.path.startsWith('/home/work')) {
          this.tab = 3;
        } else if (this.$route.path.startsWith('/class/work')) {
          this.tab = 4;
        } else if (this.$route.path.startsWith('/score/dashboard')) {
          this.tab = 5;
        } else if (this.$route.path.startsWith('/mock/exam')) {
          this.tab = 6;
        } else {
          // 即是上课也有刷机
          if (this.isFlashPractice) {
            this.tab = 0;
          } else {
            this.goTab(1);
          }
        }
        // 如果是只有刷机
      } else {
        if (this.$route.path.startsWith('/answer/history')) {
          this.tab = 2;
        } else if (this.$route.path.startsWith('/score/dashboard')) {
          this.tab = 5;
        } else if (this.$route.path.startsWith('/mock/exam')) {
          this.tab = 6;
        } else {
          this.goTab(0);
        }
      }
    });
  },
  methods: {
    goTab(tabIndex) {
      this.tab = tabIndex;
      if (tabIndex == 0) {
        this.$router.push('/dashboard');
      } else if (tabIndex == 1) {
        this.$router.push('/class/room');
      } else if (tabIndex == 2) {
        this.$router.push('/answer/history');
      } else if (tabIndex == 3) {
        this.$router.push('/home/work');
      } else if (tabIndex == 4) {
        this.$router.push('/class/work');
      } else if (tabIndex == 5) {
        this.$router.push('/score/dashboard');
      } else if (tabIndex == 6) {
        this.$router.push('/mock/exam');
      }
    },
    logout() {
      localStorage.removeItem('access_token');
      // api.logout().then(() => {
      this.$router.go(0);
      // })
    }
  }
};